import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DetailedSettlementReportComponent } from './detailed-settlement-report.component';

const routes: Routes = [
  {
    path:'**',
    component: DetailedSettlementReportComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DetailedSettlementReportRoutingModule { }
